module.exports = __webpack_public_path__ + "assets/img/d547e40f2450343557b97245af196fae.svg";